<script lang="ts">
  import { getContext } from "svelte";
  import type { Writable } from "svelte/store";

  export let value: string;
  let panelClass = "";

  export { panelClass as class };

  type TabsContext = { activeTab: Writable<string | undefined> };
  const { activeTab } = getContext<TabsContext>("tabs");
</script>

{#if $activeTab === value}
  <div class={panelClass}>
    <slot />
  </div>
{/if}
